import { FormControl, FormLabel, FormErrorMessage, Textarea } from "@chakra-ui/react";

const FormTextArea = ({field, label, errors, register, disabled, height, onChange}: any) => {
    return <FormControl isInvalid={!!errors}>
        <FormLabel>{label}</FormLabel>
        <Textarea {...register(`${field}`)} disabled={disabled} readOnly={disabled} height={height||"300px"} onChange={onChange} />
        {errors &&  <FormErrorMessage className="mt-0">{errors?.message}</FormErrorMessage>}
    </FormControl>
}
export default FormTextArea;